module.exports = {
  gofu: "https://formular.mnd.cz/",
  apiUrl: "https://data.mnd.cz",
  serverUrl: "https://www.mnd.cz",
  adminUrl:"https://www.mnd.cz/cms",
};

